module.exports = __webpack_public_path__ + "img/[凋谢].5bfd4d9f.svg";